import React from "react";
import DetailsBradcrumeSection from "../Others/DetailsBradcrumeSection";
import { Helmet } from "react-helmet";
import "./PaymentMethods.css";

export default function PaymentMethods() {
  return (
    <>
      <Helmet>
        <title>YourDoorstep - Payment Methods</title>
        <meta name="description" content="YourDoorstep - Payment Methods" />
        <meta name="keywords" content="YourDoorstep - Payment Methods" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <DetailsBradcrumeSection
        Pagename={"Payment Methods"}
        page1={[{ name: "payment-methods" }]}
      />

      <section className="shop-single">
        <div className="auto-container">
          <div className="product-details">
            <div className="basic-details">
              <div className="row clearfix bank">
                <div className="image-column col-md-4 col-sm-12 mb-0">
                  <figure
                    className="image bankimage"
                    style={{ border: "unset" }}
                  >
                    <div className="lightbox-image ImageBANKbox">
                      <img
                        src={"images/payments/icicicnbank.jpg"}
                        alt=""
                        className="ImageBANK"
                      />
                    </div>
                  </figure>
                </div>
                <div className="info-column col-md-4 col-sm-12 mb-0">
                  <div className="inner-column">
                    <ul className="product-meta bankdetails p-0">
                      <li>
                        <span className="plasdetDECS">Bank Name:</span> ICICI
                        Bank
                      </li>
                      <li>
                        <span className="plasdetDECS">Ac Holder Name:</span> WZX
                        CORPORATION
                      </li>
                      <li>
                        <span className="plasdetDECS">A/C No. :</span>{" "}
                        113005500255
                      </li>
                      <li>
                        <span className="plasdetDECS">IFSC Code:</span>{" "}
                        ICIC0001130
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="image-column col-md-4 col-sm-12 mb-0">
                  <figure
                    className="image bankimage"
                    style={{ border: "unset" }}
                  >
                    <div className="lightbox-image qrcodebank">
                      <img src={"images/payments/bankqrcode.jpg"} alt="" />
                    </div>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
